import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RadioButtons = (props) => {
    const buttons = props.buttons.map(b => (_jsxs("label", { style: { whiteSpace: 'nowrap' }, children: [_jsx("input", { type: "radio", name: props.name, checked: props.kind == b.kind, onChange: () => props.updateKind(b.kind) }), "\u00A0", b.title] }, b.kind)));
    return (_jsx("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 3fr' }, children: buttons }));
};
